module.exports = __webpack_public_path__ + "static/media/Jolyne.beaa5293.png";